import { Box, Typography } from '@mui/material';
import React from 'react';

export const MatchingPropFieldSelectShow = ({ property }) => {
  const { publicLabel, value, minValue, options, label } = property;

  const selectedOption = options.find(
    (obj) => obj.value === value || obj.value === minValue
  );

  return (
    <Box className="flex items-start justify-start gap-2">
      <Typography fontWeight={600}>{`${publicLabel || label}: `}</Typography>
      <Typography>{`${selectedOption?.label || '-'}`}</Typography>
    </Box>
  );
};
